export default "__VITE_ASSET__BB$ZEJVO__"